import React from 'react';
import {
  ArticleListSection,
  AssetsSection,
  BenefitsArea,
  CodeBlock,
  ContactBox,
  CurrencyFamilyInfo,
  CurrencyHero,
  CurrencyImageGrid,
  EmployeeCarousel,
  ExchangePartnersSection,
  PartnerSection,
  FeatureBoxSection,
  HomepageHero,
  HomepageDoc,
  Image,
  IndividualCtaButton,
  InfoBoxSection,
  InfoScanBoxSection,
  JobListingsSection,
  LogoIconSection,
  PartnerCarousel,
  PartnerEmailCapture,
  PeopleGridSection,
  PlatformHero,
  ProtocolSection,
  PurposeSection,
  Quote,
  RichText,
  SectionHeader,
  TokenInfoSection,
  ValuesGridSection,
  YoutubeVideo,
  TcnhBanner,
  TcnhInfo,
  TcnhScenarios,
  HomepageBanner,
  HomepageAds,
  HomepagePor,
  HomepageTnf
} from './slices';

function SliceZone({ allSlices }) {
  const slice = allSlices.map((s) => {
    switch (s.slice_type) {
      // These are the API IDs of the slices
      case 'article_list_section':
        return <ArticleListSection key={s.id} input={s} />;
      case 'assets_section':
        return <AssetsSection key={s.id} input={s} />;
      case 'benefits_area':
        return <BenefitsArea key={s.id} input={s} />;
      case 'code_block':
        return <CodeBlock key={s.id} input={s} />;
      case 'contact_box':
        return <ContactBox key={s.id} input={s} />;
      case 'currency_family_info':
        return <CurrencyFamilyInfo key={s.id} input={s} />;
      case 'currency_hero':
        return <CurrencyHero key={s.id} input={s} />;
      case 'currency_image_grid':
        return <CurrencyImageGrid key={s.id} input={s} />;
      case 'employee_carousel':
        return <EmployeeCarousel key={s.id} input={s} />;
      case 'exchange_partners_section':
        return <ExchangePartnersSection key={s.id} input={s} />;
      case 'partner_section':
          return <PartnerSection key={s.id} input={s} />;
      case 'feature_box_section':
        return <FeatureBoxSection key={s.id} input={s} />;
      case 'homepage_hero':
        return <HomepageHero key={s.id} input={s} />;
      case 'homepage_doc':
        return <HomepageDoc key={s.id} input={s} />;
      case 'individual_cta_button':
        return <IndividualCtaButton key={s.id} input={s} />;
      case 'image':
        return <Image key={s.id} input={s} />;
      case 'info_box_section':
        return <InfoBoxSection key={s.id} input={s} />;
      case 'info_scan_box_section':
        return <InfoScanBoxSection key={s.id} input={s} />;
      case 'job_listings_section':
        return <JobListingsSection key={s.id} input={s} />;
      case 'logo_icon_section':
        return <LogoIconSection key={s.id} input={s} />;
      case 'partner_carousel':
        return <PartnerCarousel key={s.id} input={s} />;
      case 'partner_email_capture':
        return <PartnerEmailCapture key={s.id} input={s} />;
      case 'people_grid_section':
        return <PeopleGridSection key={s.id} input={s} />;
      case 'platform_hero':
        return <PlatformHero key={s.id} input={s} />;
      case 'protocol_section':
        return <ProtocolSection key={s.id} input={s} />;
      case 'purpose__section':
        return <PurposeSection key={s.id} input={s} />;
      case 'quote':
        return <Quote key={s.id} input={s} />;
      case 'section_header':
        return <SectionHeader key={s.id} input={s} />;
      case 'text':
        return <RichText key={s.id} input={s} />;
      case 'token_info_section':
        return <TokenInfoSection key={s.id} input={s} />;
      case 'values_grid_section':
        return <ValuesGridSection key={s.id} input={s} />;
      case 'youtube_video':
        return <YoutubeVideo key={s.id} input={s} />;
      case 'tcnh_banner' :
        return <TcnhBanner key={s.id} input={s} />;
      case 'tcnh_info' :
        return <TcnhInfo key={s.id} input={s} />;
      case 'tcnh_scenarios' :
        return <TcnhScenarios key={s.id} input={s} />;
      case 'homepage_banner' :
        return <HomepageBanner key={s.id} input={s} />;
      case 'homepage_ads' :
        return <HomepageAds key={s.id} input={s} />
      case 'homepage_por' :
        return <HomepagePor key={s.id} input={s} />
      case 'homepage_tnf' :
        return <HomepageTnf key={s.id} input={s} />
      default:
        return null;
    }
  });

  return <div>{slice}</div>;
}

export { SliceZone };
